var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 6.74243L6.28272 8.32832L8.91306 7.8729C9.80098 7.71917 10.7109 7.97335 11.3907 8.56497",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7504 15.0651L13.584 18.024C12.6682 18.6744 11.4443 18.6861 10.5162 18.0534L3.33594 13.1588",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5973 13.1273L17.6494 15.1417L13.0754 11.4485L11.3929 12.673C10.7088 13.1709 9.75307 13.0368 9.23247 12.3697C8.71307 11.7042 8.81327 10.7471 9.45924 10.2036L11.2111 8.72958C12.0508 8.02312 13.1423 7.68972 14.2333 7.80647L16.9637 8.0986L20.5973 6.13452",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0759 11.4583C14.1765 12.4389 15.7374 11.9386 16.3178 11.1381",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceNewSelected);
export default __webpack_public_path__ + "static/media/ServiceNewSelected.fed273428dc6fc69fa4173adfde7e5e5.svg";
export { ForwardRef as ReactComponent };